import { render, staticRenderFns } from "./DuelAdmin.vue?vue&type=template&id=5648d875&scoped=true"
import script from "./DuelAdmin.vue?vue&type=script&lang=js"
export * from "./DuelAdmin.vue?vue&type=script&lang=js"
import style0 from "./DuelAdmin.vue?vue&type=style&index=0&id=5648d875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648d875",
  null
  
)

export default component.exports